import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createBlock(_component_b_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("label", { for: "searchDropdown" }, "Select Search Filter", -1)),
          _createVNode(_component_b_form_select, {
            id: "searchDropdown",
            options: _ctx.shareableSearches,
            modelValue: _ctx.targetSearchID,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetSearchID) = $event)),
            "text-field": "searchName",
            "value-field": "searchID",
            onChange: _ctx.initPermissions
          }, null, 8, ["options", "modelValue", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_table, {
                id: "search-share-individual",
                tableKey: _ctx.tableKeyIndividual,
                striped: "",
                items: _ctx.allIndividualPermissions,
                fields: _ctx.individualsTableFields,
                "fit-to-page": "",
                "per-page": _ctx.pageLength,
                "show-pagination": ""
              }, {
                "cell(name)": _withCtx((row) => [
                  _createElementVNode("span", null, _toDisplayString(row.item.name), 1)
                ]),
                "cell(hasAccess)": _withCtx((row) => [
                  _createVNode(_component_checkbox_input, {
                    modelValue: row.item.hasAccess,
                    "onUpdate:modelValue": ($event: any) => ((row.item.hasAccess) = $event),
                    onChange: ($event: any) => (_ctx.onReadableChange($event, row.item))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                "cell(canEdit)": _withCtx((row) => [
                  _createVNode(_component_checkbox_input, {
                    modelValue: row.item.canEdit,
                    "onUpdate:modelValue": ($event: any) => ((row.item.canEdit) = $event),
                    disabled: !row.item.hasAccess
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["tableKey", "items", "fields", "per-page"])
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_table, {
                id: "search-share-individual",
                tableKey: _ctx.tableKeyGroup,
                striped: "",
                items: _ctx.allGroupPermissions,
                fields: _ctx.groupsTableFields,
                "fit-to-page": "",
                "per-page": _ctx.pageLength,
                "show-pagination": ""
              }, {
                "cell(groupName)": _withCtx((row) => [
                  _createElementVNode("span", null, _toDisplayString(row.item.groupName), 1)
                ]),
                "cell(hasAccess)": _withCtx((row) => [
                  _createVNode(_component_checkbox_input, {
                    modelValue: row.item.hasAccess,
                    "onUpdate:modelValue": ($event: any) => ((row.item.hasAccess) = $event),
                    onChange: ($event: any) => (_ctx.onReadableChange($event, row.item))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                "cell(canEdit)": _withCtx((row) => [
                  _createVNode(_component_checkbox_input, {
                    modelValue: row.item.canEdit,
                    "onUpdate:modelValue": ($event: any) => ((row.item.canEdit) = $event),
                    disabled: !row.item.hasAccess
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["tableKey", "items", "fields", "per-page"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                variant: "primary",
                onClick: _ctx.onSubmit,
                disabled: _ctx.targetSearchID <= 0
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Submit")
                ])),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                variant: "secondary",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}